
import _ from 'lodash'

export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Select plan',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        internalSearch: {
            type: Boolean,
            default: false,
        },
        clearOnSelect: {
            type: Boolean,
            default: false,
        },
        showNoOptions: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        helpText: {
            type: String,
            default: null,
        },
        searchValue: {
            type: Function,
            default: () => {}
        },
        getSelectedValue: {
            type: Function,
            default: () => {}
        },
        // #721 round 2: a query to run on mount and keep in the search box
        // (the plan name on file, so the advisor can recognize it).
        initialQuery: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            selectableOptions: [],
            selectedValue: null,
        }
    },
    async fetch () {
        const query = this.query || ''
        const results = await this.searchValue({ query })
        this.selectableOptions = results?.items || []
    },
    computed: {
        preserveSearch () {
            return !!this.initialQuery
        },
    },
    watch: {
        // review I3: on a reloaded summary the rows mount before the survey
        // arrives, so the name on file shows up after mount. Never override a
        // query the advisor has already typed.
        initialQuery (value) {
            if (value && !this.query) {
                this.applyInitialQuery(value)
            }
        },
        value () {
            if (!_.isEqual(parseInt(this.value), this.selectedValue?.id)) {
                this.updateValue()
            }
        },
        selectedValue () {
            this.emitInput()
        },
    },
    mounted () {
        this.updateValue()
        if (this.initialQuery) {
            this.applyInitialQuery(this.initialQuery)
        }
    },
    methods: {
        async updateValue () {
            if (this.value) {
                const selectedValue = await this.getSelectedValue(this.value)
                this.selectedValue = selectedValue
            } else {
                this.selectedValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.selectedValue?.id || null)
            this.$emit('input-raw', this.selectedValue || null)
        },
        search (query) {
            // review M9: the programmatic initial query reaches here twice
            // (directly and through vue-multiselect's search watcher).
            if (query === this.query) { return }
            this.query = query
            return this.$fetch()
        },
        applyInitialQuery (value) {
            this.search(value)
            if (this.$refs.multiselect) {
                this.$refs.multiselect.search = value
            }
        },
    },
}
